import React from "react";
import Button from "../customButtons/Button";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
    const navigate = useNavigate(); // Initialize the navigate function

    // Function to handle click for the existing button (Agribusinesses)
    const handleStartTrackingClick = () => {
        navigate("/register"); // Navigate to the /register route
    };

    // New function to handle click for the 'Browse Inputs' button (Farmers)
    const handleBrowseInputsClick = () => {
        navigate("/listings"); // Navigate to the new /inputs route
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-custom-teal p-8">
            <div className="max-w-3xl text-left">
                <h1 className="text-6xl font-bold leading-tight text-white mb-6">
                    <span className="block">Empowering</span>
                    <span className="block">Agribusinesses to Save</span>
                    <span className="block">More and Waste Less</span>
                </h1>

                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                    Track product expiry, unlock local sales opportunities, and reduce waste - all with the power
                    of AI and real-time alerts.
                </p>

                {/* Container for the two buttons */}
                <div className="flex space-x-4">
                    {/* Existing Button: For Agribusinesses/Farmers who want to track products */}
                    <Button variant="primary" size="large" onClick={handleStartTrackingClick}>
                        Start Tracking Your Products
                    </Button>

                    {/* NEW Button: For Farmers who want to browse discounted inputs */}
                    <Button variant="secondary" size="large" onClick={handleBrowseInputsClick}>
                        Browse Farm Inputs
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;